<app-spinner [isLoading]="isUpdating$ | async" [isFixedPosition]="false">
  @if ({
    jobseekerWorkExperience: jobseekerWorkExperience$ | async,
    monthList: monthList$ | async,
    selectedFile: selectedFile$ | async,
    isFileUploading: isFileUploading$ | async,
    selectedSpecializationIds: selectedSpecializationIds$ | async,
    selectedSpecializations: selectedSpecializations$ | async,
    hasAttachment: selectHasAttachment$ | async,
    selectedIndustryIds: selectedIndustryIds$ | async,
    selectedIndustries: selectIndustries$ | async,
    employmentFormTypeItems: employmentFormTypeItems$ | async,
    workScheduleItems: workScheduleItems$ | async,
    selectedWorkSchedule: selectedWorkSchedule$ | async,
    selectedEmploymentFormNew: selectedEmploymentFormNew$ | async,
    isCurrent: isCurrent$ | async,
    enableAddLocationButton: isAddLocationEnabled$ | async,
    seniorityLevelItems: seniorityLevelItems$ | async,
    selectedSeniorityLevelId: selectedSeniorityLevelId$ | async,
    employmentFormType: employmentFormTypes$ | async,
    selectedFileText: selectedFileText$ | async,
    systemConfigs: systemConfigs$ | async,
    isFileSizeValid: isFileSizeValid$ | async,
    jobseekerId: jobseekerId$ | async,
    moderationLastChangeDate: moderationLastChangeDate$ | async,
    locationLevelCount: locationLevelCount$ | async,
    locationRequiredLevelCount: locationRequiredLevelCount$ | async,
    locationLastHiddenLevelCount: locationLastHiddenLevelCount$ | async,
    firstLevelParentLocationId: locationFirstLevelId$ | async
  }; as data) {
    <form [formGroup]="editForm" #ngForm="ngForm" #scrollContainer [appConnectForm]="data.jobseekerWorkExperience" class="work-experience-edit">
      <div class="work-experience-edit__header">
        <h2 class="work-experience-edit__title">{{ title | translate }}</h2>
        <button type="button" class="work-experience-edit__close" [mat-dialog-close]="true" [attr.aria-label]="'label.Close' | translate">
          <svg-icon src="/assets/icons/dialog-close.svg"></svg-icon>
        </button>
      </div>

      <div class="work-experience-edit__body">
        <div class="fields">
          <div>
            <hrra-floating-field [class.has-error]="editForm.controls['positionTitle'].hasError('required') && (editForm.controls['positionTitle'].touched || ngForm.submitted)">
              <input pInputText id="work-experience-position" maxlength="200" type="text" formControlName="positionTitle" name="positionTitle">
              <label for="work-experience-position">{{ 'label.PositionJobTitle' | translate }} *</label>
            </hrra-floating-field>
            @if (editForm.controls['positionTitle'].hasError('required') && (editForm.controls['positionTitle'].touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div class="picker">
            <div class="picker__header">
              <button
                type="button"
                class="picker__link"
                [class.has-error]="data.selectedSpecializationIds?.length === 0 && (specializationButtonIsTouched || ngForm.submitted)"
                (click)="specializationPicker(data.selectedSpecializationIds)">
                {{ 'label.SelectSpecializationSpecialty' | translate }}
              </button>
              <span class="required">*</span>
              <span class="help" [matTooltip]="'text.WorkSpecializationSpecialty' | translate">?</span>
            </div>

            @if (data.selectedSpecializations?.length) {
              <ul class="picker__groups">
                @for (headSpecializations of data.selectedSpecializations; track headSpecializations.head) {
                  <li class="picker-group">
                    <span class="picker-group__head">{{ headSpecializations.head }}</span>
                    <ul class="picker-group__items">
                      @for (specialization of headSpecializations.subSpecializations; track $index) {
                        <li class="chip">{{ specialization }}</li>
                      }
                    </ul>
                  </li>
                }
              </ul>
            }

            @if (data.selectedSpecializationIds?.length === 0 && (specializationButtonIsTouched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div class="picker">
            <div class="picker__header">
              <button
                type="button"
                class="picker__link"
                [class.has-error]="data.selectedIndustryIds?.length === 0 && (industryButtonIsTouched || ngForm.submitted)"
                (click)="industryPicker(data.selectedIndustryIds)">
                {{ 'label.SelectPositionIndustries' | translate }}
              </button>
              <span class="required">*</span>
              <span class="help" [matTooltip]="'text.WorkIndustryField' | translate">?</span>
            </div>

            @if (data.selectedIndustries?.length) {
              <ul class="picker__groups">
                @for (headIndustry of data.selectedIndustries; track headIndustry.head) {
                  <li class="picker-group">
                    <span class="picker-group__head">{{ headIndustry.head }}</span>
                    <ul class="picker-group__items">
                      @for (industry of headIndustry.subindustries; track $index) {
                        <li class="chip">{{ industry }}</li>
                      }
                    </ul>
                  </li>
                }
              </ul>
            }

            @if (data.selectedIndustryIds?.length === 0 && (industryButtonIsTouched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div>
            <div class="select-row">
              <hrra-floating-field>
                <p-select
                  inputId="work-experience-seniority-level"
                  [(ngModel)]="data.selectedSeniorityLevelId"
                  #seniorityLevelControl="ngModel"
                  [ngModelOptions]="{ standalone: true }"
                  [options]="data.seniorityLevelItems"
                  optionLabel="name"
                  optionValue="id"
                  [showClear]="!!data.selectedSeniorityLevelId"
                  [class.has-error]="!data.selectedSeniorityLevelId && (seniorityLevelControl.touched || ngForm.submitted)"
                  appDialogPanel
                  (onChange)="onSelectSeniorityLevel($event)">
                </p-select>
                <label for="work-experience-seniority-level">{{ 'label.SeniorityLevel' | translate }} *</label>
              </hrra-floating-field>
              <span class="help" [matTooltip]="'text.SelectWorkSeniorityLevel' | translate">?</span>
            </div>
            @if (!data.selectedSeniorityLevelId && (seniorityLevelControl.touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div>
            <div class="select-row">
              <hrra-floating-field>
                <p-select
                  inputId="work-experience-employment-form"
                  [(ngModel)]="data.selectedEmploymentFormNew"
                  #employmentFormTypeControl="ngModel"
                  [ngModelOptions]="{ standalone: true }"
                  [options]="data.employmentFormTypeItems"
                  optionLabel="name"
                  optionValue="id"
                  [showClear]="!!data.selectedEmploymentFormNew"
                  [class.has-error]="!data.selectedEmploymentFormNew && (employmentFormTypeControl.touched || ngForm.submitted)"
                  appDialogPanel
                  (onChange)="onSelectEmploymentFormNew($event)">
                </p-select>
                <label for="work-experience-employment-form">{{ 'label.EmploymentForm' | translate }} *</label>
              </hrra-floating-field>
              <span class="help" [matTooltip]="'text.SelectEmploymentFormType' | translate">?</span>
            </div>
            @if (!data.selectedEmploymentFormNew && (employmentFormTypeControl.touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div>
            <div class="select-row">
              <hrra-floating-field>
                <p-select
                  inputId="work-experience-work-schedule"
                  [(ngModel)]="data.selectedWorkSchedule"
                  #workScheduleControl="ngModel"
                  [ngModelOptions]="{ standalone: true }"
                  [options]="data.workScheduleItems"
                  optionLabel="name"
                  optionValue="id"
                  [showClear]="!!data.selectedWorkSchedule"
                  [class.has-error]="!data.selectedWorkSchedule && (workScheduleControl.touched || ngForm.submitted)"
                  appDialogPanel
                  (onChange)="onSelectWorkSchedule($event)">
                </p-select>
                <label for="work-experience-work-schedule">{{ 'label.Schedule' | translate }} *</label>
              </hrra-floating-field>
              <span class="help" [matTooltip]="'text.SelectWorkSchedule' | translate">?</span>
            </div>
            @if (!data.selectedWorkSchedule && (workScheduleControl.touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          <div>
            <hrra-floating-field [class.has-error]="(editForm.controls['employer'].touched || ngForm.submitted) && editForm.controls['employer'].hasError('required')">
              <input pInputText id="work-experience-employer" maxlength="200" type="text" formControlName="employer" name="employer">
              <label for="work-experience-employer">{{ 'label.CompanyEmployer' | translate }} *</label>
            </hrra-floating-field>
            @if ((editForm.controls['employer'].touched || ngForm.submitted) && editForm.controls['employer'].hasError('required')) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
          </div>

          @if (data.locationLevelCount && data.locationRequiredLevelCount && data.firstLevelParentLocationId) {
            <div class="location">
              <div class="location__title">
                <span>{{ 'label.Locality' | translate }}</span>
                <span class="help" [matTooltip]="'text.SelectLocationType' | translate">?</span>
              </div>

              <div class="location__types">
                @for (option of data.employmentFormType; track option.announcementEmploymentFormTypeId) {
                  <label class="radio">
                    <input
                      type="radio"
                      class="radio__control"
                      formControlName="employmentFormTypeId"
                      [value]="option.announcementEmploymentFormTypeId"
                      (change)="updateEmploymentFormType(option.announcementEmploymentFormTypeId)">
                    <span class="radio__label">{{ option.name }}</span>
                  </label>
                }
              </div>

              @if (editForm.get('employmentFormTypeId')?.value !== employmentFormTypeEnum.WorkFromHome) {
                <div formArrayName="extendedLocationPathList" class="location__pickers">
                  @for (extendedLocation of locationControl.controls; track extendedLocation; let i = $index) {
                    <div class="location__row">
                      <hrra-location-picker
                        class="location__picker"
                        [formControlName]="i"
                        [rowStyled]="true"
                        [locationLevelCount]="data.locationLevelCount"
                        [firstLevelParentLocationId]="data.firstLevelParentLocationId"
                        [requiredLevelCount]="data.locationRequiredLevelCount"
                        [lastHiddenLevelCount]="data.locationLastHiddenLevelCount"
                        [class.has-error]="
                          (editForm.hasError('SameExtendedLocation') ||
                            editForm.hasError('ExtendedLocationsRequired') ||
                            editForm.controls['extendedLocationPathList'].hasError('maxlength')) &&
                          (editForm.controls['extendedLocationPathList'].touched || ngForm.submitted)
                        ">
                      </hrra-location-picker>

                      <div class="location__actions">
                        <button type="button" class="icon-button" (click)="resetLocation(i)">
                          <svg-icon [svgClass]="'reset-icon'" src="/assets/icons/reset.svg"></svg-icon>
                        </button>
                        @if (i > 0) {
                          <button type="button" class="icon-button" (click)="removeLocation(i)">
                            <svg-icon [svgClass]="'delete-icon'" src="/assets/icons/delete-red.svg"></svg-icon>
                          </button>
                        }
                      </div>
                    </div>
                  }
                </div>

                @if ((editForm.controls['extendedLocationPathList'].touched || ngForm.submitted)) {
                  @if (editForm.hasError('SameExtendedLocation')) {
                    <mat-error class="validation-message">{{ 'message.SameExtendedLocation' | translate }}</mat-error>
                  }
                  @if (editForm.hasError('ExtendedLocationsRequired')) {
                    <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
                  }
                  @if (editForm.controls['extendedLocationPathList'].hasError('maxlength')) {
                    <mat-error class="validation-message">
                      {{ 'message.ExtendedLocationMaxCountMessage' | translate: { count: editForm.controls['extendedLocationPathList'].errors['maxlength'].requiredLength } }}
                    </mat-error>
                  }
                }

                @if (data.enableAddLocationButton) {
                  <button type="button" class="location__add" (click)="addNewLocation()">
                    <svg-icon class="location__add-icon" src="/assets/icons/plus-small.svg"></svg-icon>
                    {{ 'label.NewLocation' | translate }}
                  </button>
                }
              }
            </div>
          }

          <div>
            <div class="dates">
              <div class="dates__group">
                <span class="dates__caption">{{ 'label.StartDate' | translate }}</span>
                <div class="dates__fields">
                  <hrra-floating-field>
                    <p-select inputId="work-experience-date-from-month" formControlName="dateFromMonth" [options]="data.monthList" optionLabel="name" optionValue="value" [showClear]="true" appDialogPanel></p-select>
                    <label for="work-experience-date-from-month">{{ 'label.MonthLabel' | translate }}</label>
                  </hrra-floating-field>

                  <hrra-floating-field class="dates__year" [class.has-error]="editForm.controls['dateFromYear'].invalid && (editForm.controls['dateFromYear'].touched || ngForm.submitted)">
                    <input pInputText id="work-experience-date-from-year" maxlength="4" type="text" formControlName="dateFromYear" name="dateFromYear">
                    <label for="work-experience-date-from-year">{{ 'label.YearLabel' | translate }} *</label>
                  </hrra-floating-field>
                </div>
              </div>

              <div class="dates__group">
                <span class="dates__caption">{{ 'label.EndDate' | translate }}</span>
                <div class="dates__fields">
                  <hrra-floating-field>
                    <p-select inputId="work-experience-date-to-month" formControlName="dateToMonth" [options]="data.monthList" optionLabel="name" optionValue="value" [showClear]="true" appDialogPanel></p-select>
                    <label for="work-experience-date-to-month">{{ 'label.MonthLabel' | translate }}</label>
                  </hrra-floating-field>

                  <hrra-floating-field class="dates__year" [class.has-error]="(editForm.hasError('RequiredYear') && ngForm.submitted) || (editForm.controls['dateToYear'].hasError('pattern') && (editForm.controls['dateToYear'].touched || ngForm.submitted))">
                    <input pInputText id="work-experience-date-to-year" maxlength="4" type="text" formControlName="dateToYear" name="dateToYear">
                    <label for="work-experience-date-to-year">{{ 'label.YearLabel' | translate }}</label>
                  </hrra-floating-field>
                </div>
              </div>
            </div>

            @if (editForm.controls['dateFromYear'].hasError('required') && (editForm.controls['dateFromYear'].touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
            @if (editForm.controls['dateFromYear'].hasError('pattern') && (editForm.controls['dateFromYear'].touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.IncorrectFormat' | translate }}</mat-error>
            }
            @if (editForm.hasError('RequiredYear') && ngForm.submitted) {
              <mat-error class="validation-message">{{ 'message.MandatoryField' | translate }}</mat-error>
            }
            @if (editForm.controls['dateToYear'].hasError('pattern') && (editForm.controls['dateToYear'].touched || ngForm.submitted)) {
              <mat-error class="validation-message">{{ 'message.IncorrectFormat' | translate }}</mat-error>
            }
            @if (editForm.hasError('date') && (editForm.controls['dateToYear'].touched || ngForm.submitted) && editForm.controls['dateToYear'].valid && editForm.controls['dateFromYear'].valid) {
              <mat-error class="validation-message">{{ 'message.StartDateMustNotComeAfterEndDate' | translate }}</mat-error>
            }
          </div>

          <label class="checkbox">
            <input type="checkbox" class="checkbox__control" formControlName="isCurrent" (change)="onCurrentExperience(data.isCurrent)">
            <span class="checkbox__label">{{ 'label.ICurrentlyWorkHere' | translate }}</span>
          </label>

          <div>
            <hrra-floating-field>
              <textarea pTextarea id="work-experience-description" class="description" formControlName="description" name="description"></textarea>
              <label for="work-experience-description">{{ 'label.JobDescription' | translate }}</label>
            </hrra-floating-field>
            <p class="hint">{{ 'text.EnterShortListOfDuties' | translate }}</p>
          </div>

          <div class="attachment">
            @if (data.hasAttachment) {
              <button type="button" class="attachment-link" (click)="downloadAttachment(data.jobseekerWorkExperience?.experienceId, data.jobseekerId)">
                <svg-icon src="/assets/icons/profile-attachment.svg" class="attachment-link__icon"></svg-icon>
                {{ 'label.Attachment' | translate }}
              </button>
            }

            <hrra-file-upload
              [label]="(data.hasAttachment ? 'label.Change' : 'label.AttachDocument') | translate"
              [hint]="'label.EgRecommendationLetter' | translate"
              [fileName]="data.selectedFile?.filename != null ? data.selectedFileText : null"
              [uploading]="data.isFileUploading"
              [invalid]="data.isFileSizeValid === false"
              (fileSelected)="onFileSelect($event, data.systemConfigs.jobseeker.jobseekerAttachmentMaxSize, data.jobseekerId)">
            </hrra-file-upload>

            @if (data.isFileSizeValid === false) {
              <mat-error class="validation-message">{{ 'message.JobseekerFileSizeValidation' | translate }}</mat-error>
            }
          </div>
        </div>

        <div class="actions">
          <button
            type="submit"
            class="actions__button actions__button--save"
            (click)="
              onSave(
                data.selectedFile?.filename,
                data.selectedSpecializationIds,
                data.selectedIndustryIds,
                data.selectedSeniorityLevelId,
                data.selectedWorkSchedule,
                data.selectedEmploymentFormNew,
                data.isFileSizeValid,
                data.jobseekerId,
                data.moderationLastChangeDate
              )
            ">
            {{ 'label.Save' | translate }}
          </button>
          <button type="button" class="actions__button actions__button--cancel" [mat-dialog-close]="true">{{ 'label.Cancel' | translate }}</button>
        </div>
      </div>
    </form>
  }
</app-spinner>
